
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import AsnModule from "@/store/modules/asn";
import DataInterchangeModule from "@/store/modules/dataInterchange";
import { AsnImportHistory, AsnImportHistoryResponse } from "@/models/api/asn/history";
import { getModule } from "vuex-module-decorators";
import { GetImportHeaderResponse } from "@/models/api/dataInterchange/importHeader";
import { GetImportOrdersResponse } from "@/models/api/dataInterchange/importOrder";


const asnModule = getModule(AsnModule);
const dataInterchangeModule = getModule(DataInterchangeModule);

@Component
export default class DataInterchangeModal extends Vue {

    @Prop({ default: null })
    ImportHeaderId;

    HeaderInfo: GetImportHeaderResponse = null;
    OrdersInfo: GetImportOrdersResponse = null;

    IsLoading: boolean = false;


    async created() {
        this.IsLoading = true;

        this.HeaderInfo = await dataInterchangeModule.getImportHeader(this.ImportHeaderId);
        this.OrdersInfo = await dataInterchangeModule.getImportOrders(this.ImportHeaderId);

        this.IsLoading = false;
    }

    async onClickHeaderNumber(importHeaderId){
        this.$emit('import-header', importHeaderId);
    }
}
